export default {"src":"/_next/static/media/legal.3b800e9e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};